import React, { ReactNode } from "react";
import { useSelector } from "react-redux";
import Skeleton from "react-loading-skeleton";

import { RootState } from "../../store/store";

import "react-loading-skeleton/dist/skeleton.css";
import "./style.css";

interface ParentComponentProps {
  children: ReactNode;
  width?: string;
  height?: string;
}

const SkeletonLineWrapper: React.FC<ParentComponentProps> = ({
  children,
  width,
  height
}: any) => {
  const sessionData = useSelector((state: RootState) => state.session);
  const isLoading = sessionData.status !== "success";

  return isLoading ? (
    <Skeleton
      baseColor="#494A4C"
      highlightColor="#252526"
      className="skeleton-wrapper skeleton-wrapper-default"
      width={width}
      height={height}
    />
  ) : (
    children
  );
};

export default SkeletonLineWrapper;
